import React from 'react';
import CbbDropdownV2 from './componentsV2/CbbAdaptiveDropdownV2';
import { sortOptionsV2 } from './constantsV2';

interface Props {
  selectedName?: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  rootClassName: string;
  selectClassName?: string;
}

const UnitsSortingV2: React.FC<Props> = ({
  selectedName,
  onChange,
  rootClassName,
  selectClassName = 'w-[226px] -left-0.1 mt-0 text-14-26-0.3',
}) => {
  return (
    <CbbDropdownV2
      ariaLabel="Sort by"
      rootClassName={rootClassName}
      nameSelected={selectedName || sortOptionsV2.RECOMMENDED}
      selectClassName={selectClassName}
      textBeforeSelect=""
      onChange={onChange}
      options={[
        sortOptionsV2.RECOMMENDED,
        sortOptionsV2.PRICE_HIGHEST_FIRST,
        sortOptionsV2.PRICE_LOWEST_FIRST,
        sortOptionsV2.SQUARE_FEET,
        sortOptionsV2.BEDROOMS,
        sortOptionsV2.RECENT_CHANGES,
      ]}
    />
  );
};

export default UnitsSortingV2;
